import Loadable from 'react-loadable'
import LoadingPage from 'views/LoadingPage'

export default Loadable({
  loader: () => import('./Account'),
  loading: LoadingPage
})
